<script setup>
import LocationFilter from './LocationFilter.vue'
import SearchBar from './SearchBar.vue'
import SessionFilter from './SessionFilter.vue'
import WorkshopFilter from './WorkshopFilter.vue'
import DaysHeader from './DaysHeader.vue'
// import GridLocationHeaders from './GridLocationHeaders.vue'

import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
import { storeToRefs } from 'pinia';

const store = useScheduleItemStore()
const { getLocations } = storeToRefs(store)

const handleToggleViewClick = (view) => {
    store.setView(view)
}

const showBookmarks = ( view ) => {
    handleToggleViewClick( view )
    store.setCurrentFilter( 'bookmark', 'bookmark' )
}

const handleShowFilters = () => {
    if( store.showFilters === false ) {
        store.showFilters = true
    } else {
        store.showFilters = false
    }
    // console.log( 'dispatch showFiltersChanged event' )
    const showFiltersChanged = new CustomEvent( 'showFiltersChanged', { 'detail': { 'state': '' } } )
    document.dispatchEvent( showFiltersChanged )
}

const handleClearFilters = () => {
    store.clearAllFilters()
}

</script>
<template>
    <header class="sles__header">
        <div class="sles__header__bar">
            <h2 class="sles__header__title">Full schedule</h2>

            <div class="sles__header__views">
                <input v-if="store.bookmarkedIDs.length > 0" id="list_favs" name="schedule-view" type="radio" checked="checked" value="sles--show-list--favs" @click="showBookmarks( 'favs' )" />
                <label v-if="store.bookmarkedIDs.length > 0" for="list_favs" onclick="" :class="store.view === 'favs' ? 'active' : ''"><span class="screen-reader-text">Favourites</span><svg class="svgicon"><use xlink:href="#svg-star"></use></svg></label>

                <input id="list" name="schedule-view" type="radio" checked="" value="sles--show-list" @click="handleToggleViewClick( 'list' )" />
                <label for="list" onclick="" :class="store.view === 'list' ? 'active' : ''"><span class="screen-reader-text">List</span><svg class="svgicon"><use xlink:href="#svg-view-search-list"></use></svg></label>

                <input id="compact-timetable" name="schedule-view" type="radio" checked="checked" value="sles--show-schedule--compact" @click="handleToggleViewClick( 'compact' )" />
                <label for="compact-timetable" onclick="" :class="store.view === 'compact' ? 'active' : ''"><span class="screen-reader-text">Compact timetable</span><svg class="svgicon"><use xlink:href="#svg-view-timetable--compact"></use></svg></label>

                <input id="large-timetable" name="schedule-view" type="radio" checked="" value="sles--show-schedule--large" @click="handleToggleViewClick( 'large' )" />
                <label for="large-timetable" onclick="" :class="store.view === 'large' ? 'active' : ''"><span class="screen-reader-text">Large timetable</span><svg class="svgicon"><use xlink:href="#svg-view-timetable--large"></use></svg></label>
            </div>

            <div class="sles__header__print">
                <button id="print-schedule" class="reset-button"><svg class="svgicon"><use xlink:href="#svg-pdf"></use></svg></button>
            </div>

            <div class="sles__header__filters" :class="store.showFilters === true ? 'showFilters' : ''">
                <SearchBar />
                <div class="sles__header__filters__filter-wrap">
                    <LocationFilter :locations="getLocations" />
                    <SessionFilter />
                    <WorkshopFilter />
                </div>
            </div>

            <div class="sles__header__days">
                <DaysHeader :dateTimes="store.dateTimes" />
            </div>

            <div class="sles__header__toggle-filters">
                <ul class="sles__header__toggle-filters__list">
                    <li class="sles__header__toggle-filter sles__header__toggle-filter--open" :class="store.filterActive === true ? 'active' : ''">
                        <a href="#open-filters" @click.prevent="handleShowFilters()"><span class="screen-reader-text">Compact timetable</span><svg class="svgicon"><use xlink:href="#svg-filter"></use></svg></a>
                    </li>
                    <li v-if="store.filterActive === true" class="sles__header__toggle-filter sles__header__toggle-filter--clear">
                        <a href="#clear-filters" @click.prevent="handleClearFilters()"><span class="screen-reader-text">Compact timetable</span><svg class="svgicon"><use xlink:href="#svg-filter-off"></use></svg></a>
                    </li>
                </ul>
            </div>
            <!-- <GridLocationHeaders v-if="store.view === 'large'" /> -->
        </div>
    </header>
</template>